import { useState, useCallback } from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel,
  AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle
} from '@/components/ui/alert-dialog';

export function useConfirmDialog() {
  const [state, setState] = useState({ open: false, title: '', description: '', resolve: null });

  const confirm = useCallback((title, description) => {
    return new Promise((resolve) => {
      setState({ open: true, title, description, resolve });
    });
  }, []);

  const handleConfirm = () => { state.resolve?.(true); setState(s => ({ ...s, open: false })); };
  const handleCancel = () => { state.resolve?.(false); setState(s => ({ ...s, open: false })); };

  const ConfirmDialog = () => (
    <AlertDialog open={state.open} onOpenChange={(o) => { if (!o) handleCancel(); }}>
      <AlertDialogContent className="bg-[#141414] border-[#27272A]">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">{state.title}</AlertDialogTitle>
          <AlertDialogDescription className="text-zinc-400">{state.description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-[#0A0A0A] border-[#27272A] text-zinc-300 hover:bg-[#1C1C1E]" data-testid="confirm-dialog-cancel">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} className="bg-red-600 hover:bg-red-700 text-white" data-testid="confirm-dialog-confirm">Confirmar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );

  return { confirm, ConfirmDialog };
}
